import React, { Component, Fragment } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import DefaultModal from 'Modals/DefaultModal';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import Loader from 'Pure/Loader';
import PDFIcon from 'Icons/PDFIcon';
import bemit from 'Functions/bemit';
import { action, URL } from 'Shared/Routes';
export default class EmployeeBookingRow extends Component {
  state = {
    loading: false
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      data,
      blank = false,
      fields
    } = props;
    numeral.locale('en');
    moment.locale('fr');
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-red']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement("div", {
      className: 'c-dashboard__row ' + 'Booking-' + data.status
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-date"
    }, moment(data.date).format('DD/MM/YYYY')), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-hours"
    }, data.coworking_space.type === "b_seminar" ? data.type === "morning" ? "Matin" : data.type === "afternoon" ? "Après midi" : "La journée" : data.start_hour + 'h - ' + data.end_hour + 'h'), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-coworking_space_name"
    }, data.coworking_space.name, ' - ', data?._etablishment?.name), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-address"
    }, data._etablishment?.address?.line_1, /*#__PURE__*/React.createElement("br", null), data._etablishment?.address?.line_2 ? /*#__PURE__*/React.createElement(Fragment, null, data._etablishment?.address?.line_2, /*#__PURE__*/React.createElement("br", null)) : undefined, data._etablishment?.address?.postal_code, ",", data._etablishment?.address?.city), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-number_of_people"
    }, data.number_of_people));
    return output;
  }
}
